import BoxDrawer from 'components/BoxDrawer';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import * as React from 'react';
import TopicWhoKnowsAbout from 'views/Topic/Components/TopicWhoKnowsAbout';
import { useTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    topicId: string;
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const TopicWhoKnowsAboutDrawer: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { onClose } = props;

    return (
        <BoxDrawer
            open
            overflow="hidden"
            onClose={onClose}
            title={t("Views.Topic.Dialogs.TopicWhoKnowsAboutDrawer.BoxTitle")}
        >
            <MuiPaper dense fullHeight elevation={0}>

                <TopicWhoKnowsAbout
                    topicId={props.topicId}
                    pageCount={null}
                />

            </MuiPaper>

        </BoxDrawer>
    );
};

export default TopicWhoKnowsAboutDrawer;